<template>
    <div>
      <div id="bb">
        <div class="c-panel dashboard-container">

          <div style="width: 50%;">
            <div style="width: 100%;margin-top: 20px;">
              <span style="margin-left: 20px">教师过滤：</span>
              <el-select
                size="small"
                v-model="selectedTeacher"
                :disabled="lockLoading"
                @change="seachteacher()"
                placeholder="全部教师"
                clearable
                filterable
              >
                <el-option
                  style="margin-left: 10px"
                  v-for="teacher in teachers"
                  :key="teacher.id"
                  :label="teacher.realname"
                  :value="teacher.id"
                >
                </el-option>
              </el-select>
            </div>

      <!--  ============================恢复=================================  -->
        <!-- <div style="width: 100%;margin-top: 40px;">
          <span style="margin-left:20px;">过滤显示：</span>
          <el-select size="small" v-model="studentName" :disabled="lockLoading" filterable @change="btnSchedule"
            placeholder="全部学生" clearable >
            <el-option style="margin-left: 10px;" v-for="teacher in studentsList" :key="teacher.id"
              :label="teacher.realname" :value="teacher.id">
            </el-option>
          </el-select>
        </div> -->


  <!--  ============================ （开始）=================================  -->
          <div style="width: 100%;margin-top: 20px;">
            <span style="margin-left: 20px">线下学员：</span>
            <el-select
              size="small"
              v-model="studentName_s"
              :disabled="lockLoading"
              filterable
              @change="btnSchedule"
              placeholder="请选择线下学员"
              clearable
              @clear="handleclear1"
            >
              <el-option
                style="margin-left: 10px"
                v-for="teacher in studentsList_s"
                :key="teacher.id"
                :label="teacher.realname"
                :value="teacher.id"
              >
              <span style="margin-left: 10px" @click="handlechange1(teacher.realname)">{{ teacher.realname }}</span>
              </el-option>
            </el-select>
          </div>

          <div style="width: 100%;margin-top: 20px;">
            <span style="margin-left: 20px">规划学员：</span>
            <el-select
              size="small"
              v-model="studentName"
              :disabled="lockLoading"
              filterable
              @change="btnSchedule"
              placeholder="请选择规划学员"
              clearable
              @clear="handleclear2"
            >
              <el-option
                style="margin-left: 10px"
                v-for="teacher in studentsList"
                :key="teacher.id"
                :label="teacher.realname"
                :value="teacher.id"
              >
              <span style="margin-left: 10px" @click="handlechange2(teacher.realname)">{{ teacher.realname }}</span>
              </el-option>
            </el-select>
          </div>

        </div>
  <!--  ============================ （结束） =================================  -->

          <div style="width: 50%;">
            <div style=" display: flex;justify-content: center;padding-top: 20px;">
              <div  style="width: 50%;">
                <!-- <el-date-picker
                  style="width: 100%;"
                  value-format="yyyy-MM-dd"
                  v-model="time"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  clearable>
                </el-date-picker> -->
              </div>


              <!-- <el-button
              type="primary"
              style="margin-left: 20px"
              @click="classSchedule"
              size="medium"
              icon="el-icon-download"
              class="btns">导出课表</el-button> -->
              <el-button
              type="primary"
              style="margin-left: 20px;width: 115px;"
              @click="handleSynchronization"
              size="medium"
              icon="el-icon-download"
              class="btns">一键同步</el-button>


            </div>
            <div style=" display: flex;justify-content: center;padding-top: 20px;">
                <div  style="width: 50%;">
                  <!-- <el-date-picker
                    style="width: 100%; opacity: 0;"
                    value-format="yyyy-MM-dd"
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable>
                  </el-date-picker> -->
                </div>
                <!-- <el-button
                  style="margin-left: 20px"
                  type="primary"
                  @click="oneTouch"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >一键结课</el-button> -->
                  <!-- <el-button
                  style="margin-left: 20px;width: 115px;"
                  type="primary"
                  @click="handleRevoke"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >一键撤销</el-button> -->
                   <el-button
              type="primary"
              style="margin-left: 20px"
              @click="classSchedule"
              size="medium"
              icon="el-icon-download"
              class="btns">导出课表</el-button>
            </div>


            <div style=" display: flex;justify-content: center;padding-top: 20px;">
                <div  style="width: 50%;">
                  <!-- <el-date-picker
                    style="width: 100%; opacity: 0;"
                    value-format="yyyy-MM-dd"
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable>
                  </el-date-picker> -->
                </div>
                <!-- <el-button
                  style="margin-left: 20px"
                  type="primary"
                  @click="oneTouch"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >一键结课</el-button> -->
                  <!-- <el-button
                  style="margin-left: 20px;width: 115px;"
                  type="primary"
                  @click="handleRevoke"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >一键撤销</el-button> -->
                   <el-button
                    type="primary"
                    style="margin-left: 20px"
                    @click="handleDelete"
                    size="medium"
                    icon="el-icon-delete"
                    class="btns">一键删除</el-button>
            </div>

            <div style=" display: flex;justify-content: center;padding-top: 20px;">
              <div  style="width: 50%;">
                  <!-- <el-date-picker
                    style="width: 100%; opacity: 0;"
                    value-format="yyyy-MM-dd"
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable>
                  </el-date-picker> -->
              </div>
              <!-- <el-button
                  style="margin-left: 20px;width: 115px;"
                  type="primary"
                  @click="handleRevokes('同步')"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >同步</el-button> -->

              <!-- <el-upload
                  :show-file-list="false"
                  :action="file"
                  class="upload-demo"
                  ref="upload"
                  :on-success="handleSuccess"
                >
                  <el-button
                    style="margin-left: 20px"
                    type="primary"
                    size="medium"
                    icon="el-icon-upload"
                    class="btns"
                    >导入课表</el-button
                  >
              </el-upload> -->
            </div>

            <div style=" display: flex;justify-content: center;padding-top: 20px;">
              <div  style="width: 50%;">
                  <!-- <el-date-picker
                    style="width: 100%; opacity: 0;"
                    value-format="yyyy-MM-dd"
                    v-model="time"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    clearable>
                  </el-date-picker> -->
              </div>
              <!-- <el-button
                  style="margin-left: 20px;width: 115px;"
                  type="primary"
                  @click="handleRevokes('撤销')"
                  icon="el-icon-switch-button"
                  size="medium"
                  class="btns"
                  >撤销</el-button> -->

              <!-- <el-upload
                  :show-file-list="false"
                  :action="file"
                  class="upload-demo"
                  ref="upload"
                  :on-success="handleSuccess"
                >
                  <el-button
                    style="margin-left: 20px"
                    type="primary"
                    size="medium"
                    icon="el-icon-upload"
                    class="btns"
                    >导入课表</el-button
                  >
              </el-upload> -->
            </div>

          </div>

          <!-- <el-button type="primary" style="margin-left: 20px;" @click="btnSchedule">搜索学生</el-button> -->
          <!--
          <div class="c-panel">
            <span class="manage">导出时间范围： </span>
            <el-date-picker
              size="small"
              @change="seachtime()"
              v-model="value1"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </div> -->
        </div>

        <div class="add_andmagess" v-if="selectedTeacher">
          <span
            >周一上课意愿：{{
              teacherMonStatus == 1 ? "接受排课" : "不接受排课"
            }}</span
          >
          <span
            >周六课节数不超过：{{
              teacherSatNum == 1
                ? "服从安排"
                : teacherSatNum == 2
                ? "不排课"
                : teacherSatNum == 3
                ? "排一节"
                : teacherSatNum == 4
                ? "排二节"
                : teacherSatNum == 5
                ? "排三节"
                : teacherSatNum == 6
                ? "排四节"
                : teacherSatNum == 7
                ? "排五节"
                : teacherSatNum == 8
                ? "排六节"
                : ""
            }}</span
          >
          <span
            >周日课节数不超过：{{
              teacherSunNum == 1
                ? "服从安排"
                : teacherSunNum == 2
                ? "不排课"
                : teacherSunNum == 3
                ? "排一节"
                : teacherSunNum == 4
                ? "排二节"
                : teacherSunNum == 5
                ? "排三节"
                : teacherSunNum == 6
                ? "排四节"
                : teacherSunNum == 7
                ? "排五节"
                : teacherSunNum == 8
                ? "排六节"
                : ""
            }}</span
          >
          <span v-if="teacherAddress">地址：{{ teacherAddress }}</span>
        </div>

        <!-- 底部下划线111 -->
        <div class="hr dotted"></div>

        <div class="demo-app">
          <div class="demo-app-main">
            <div id="external-events">
              <p>
                <strong class="dragheader">拖拽课程进行排课</strong>
              </p>

              <!-- <el-radio-group v-model="tabPosition" style="margin-bottom: 10px; display: flex;margin-left: -8px;">
                <el-radio-button @click.native="handleClickTba('xueyeke')" label="xueyeke">学业课</el-radio-button>
                <el-radio-button @click.native="handleClickTba('jiatingke')" label="jiatingke">家庭课</el-radio-button>
                <el-radio-button @click.native="handleClickTba('zhenduanke')" label="zhenduanke">诊断课</el-radio-button>
              </el-radio-group> -->

              <div style="display: flex;width: 235px;overflow: auto;">
                <el-radio-group v-model="tabPosition" style="margin-bottom: 10px; display: flex;margin-left: -8px;" v-for="(itme,index) in optionList5" :key="index">
                  <el-radio-button @click.native="handleClickTba(itme)" :label="itme.id">{{ itme.categoryName }}</el-radio-button>
                </el-radio-group>
              </div>


              <div class="fc-event fc-h-event fc-daygrid-event fc-daygrid-block-event"  v-for="course in courses" :key="course.id">
                <div :data-id="course.id" class="fcevent">
                  <div class="fc-event-main">{{ course.categoryName }} </div>
                  <button  class="colorButton"  @click="handleButtonClick(course.id)"></button>
                </div>
              </div>

            </div>

            <!-- 添加排课弹层 -->
            <!-- title="添加排课:(带*为必填项)" -->
            <el-dialog
              :visible.sync="dialogVisible"
              @close="handleCler"
              :width="'80%'"
            >

              <el-tabs v-model="activeName" type="card" @tab-click="handleClicktab">
                <el-tab-pane label="默认排课" name="second">
                  <el-form
                      ref="ruleForm"
                      :model="ruleForm"
                      :rules="rules"
                      @submit="submitForm"
                    >
                      <el-form-item label="课程" label-width="100px">
                        <el-input
                          v-model="courses.categoryName"
                          autocomplete="off"
                          :disabled="true"
                          type="text"
                        ></el-input>
                      </el-form-item>
                      <el-form-item label="日期" label-width="100px">
                        <el-date-picker
                          type="date"
                          placeholder="选择日期"
                          style="width: 100%"
                          value-format="yyyy-MM-dd"
                          v-model="courses.date"
                          clearable
                          
                        >
                        </el-date-picker>
                      </el-form-item>
                      <el-form-item
                        label="开始时间"
                        label-width="100px"
                        prop="startTime"
                      >
                        <mz-time-select
                          @clena="clean"
                          :timePeriod="'start'"
                          @startTimeSelect="startTimeSelect"
                          :childPlaceholder="'开始时间'"
                          v-model="ruleForm.startTime"
                          :valueTime="ruleForm.startTime"
                        ></mz-time-select>
                      </el-form-item>
                      <el-form-item label="结束时间" label-width="100px" prop="endTime">
                        <mz-time-select
                          @clean="clean"
                          :timePeriod="'end'"
                          :childPlaceholder="'结束时间'"
                          @startTimeSelect="startTimeSelect"
                          v-model="ruleForm.endTime"
                          :valueTime="ruleForm.endTime"
                        ></mz-time-select>
                      </el-form-item>
                      <el-form-item label="学员" label-width="100px">
                        <el-select
                          style="width: 100%"
                          v-model="studentIds"
                          multiple
                          placeholder="请选择"
                          filterable
                          @change="handleblur"
                        >
                          <el-option
                            style="margin-left: 10px"
                            v-for="item in studentList"
                            :key="item.id"
                            :label="item.realname"
                            :value="item.id"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="班型" label-width="100px">
                        <div v-if="!ClassType" style="position: absolute; color: #F56C6C; width: 1px; height: 1px;z-index: 111111; margin-left: -52px;">*</div>
                        <el-select  style="width: 100%" v-model="ClassType" placeholder="请选择班型" filterable >
                          <el-option  style="margin-left: 10px"   v-for="item in classPersonTypeList1"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="老师"
                        label-width="100px"
                        prop="selectedTeacher"
                      >
                      <!-- v-if="courses.date && ruleForm.startTime && ruleForm.endTime" -->
                        <el-select
                         v-if="courses.date && ruleForm.startTime && ruleForm.endTime"
                          placeholder="请选择教师"
                          style="width: 100%"
                          v-model="ruleForm.selectedTeacher"
                          clearable
                          filterable
                          @change="handleClick"
                          @visible-change="techerBtnList">
                          <el-option
                            style="margin-left: 10px"
                            v-for="teacher in timeTeachers"
                            :key="teacher.id"
                            :label="teacher.realname"
                            :value="teacher.id"
                          >
                          </el-option>
                        </el-select>
                        <el-select
                          v-else
                          placeholder="请选择教师"
                          disabled
                          style="width: 100%"
                          filterable
                          v-model="ruleForm.selectedTeacher"
                        ></el-select>
                      </el-form-item>

                      <el-form-item label="上课人员类型" label-width="100px">
                        <el-select  style="width: 100%" v-model="classPersonType" placeholder="请选择"  filterable @focus="handleChanges" >
                          <el-option   style="margin-left: 10px"   v-for="item in classPersonTypeList"  :key="item.id"  :label="item.name"  :value="item.id"  ></el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        label="上课方式"
                        label-width="100px"
                        style="text-align: left"
                      >
                        <el-radio-group v-model="educationType">
                          <el-radio :label="1" :disabled="isdisabled1">网课</el-radio>
                          <el-radio :label="2" :disabled="isdisabled2">上门</el-radio>
                          <el-radio :label="3" :disabled="isdisabled3">门店</el-radio>
                        </el-radio-group>
                      </el-form-item>
                      <el-form-item label="循环排课" label-width="100px">
                        <el-select
                          placeholder="请选择循环排课类型"
                          style="width: 100%"
                          clearable
                          filterable
                          v-model="relativeTime"
                        >
                          <el-option
                            style="margin-left: 10px"
                            v-for="item in relativeTimes"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item
                        v-if="relativeTime == 3"
                        label="星期选择"
                        label-width="100px"
                      >
                        <el-checkbox-group v-model="checkList" style="text-align: left">
                          <el-checkbox label="1">周一</el-checkbox>
                          <el-checkbox label="2">周二</el-checkbox>
                          <el-checkbox label="3">周三</el-checkbox>
                          <el-checkbox label="4">周四</el-checkbox>
                          <el-checkbox label="5">周五</el-checkbox>
                          <el-checkbox label="6">周六</el-checkbox>
                          <el-checkbox label="7">周日</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                      <el-form-item
                        label="排课次数"
                        style="text-align: left"
                        label-width="100px"
                        v-if="relativeTime != 4"
                      >
                        <el-input-number
                          v-model="num"
                          @change="handleChange"
                          :min="1"
                          :max="99999"
                          label="描述文字"
                        ></el-input-number>
                      </el-form-item>
                      <el-table
                        border
                        ref="multipleTable"
                        :data="studentList"
                        height="300"
                        tooltip-effect="dark"
                        style="width: 100%"
                        @selection-change="handleSelectionChange"
                      >
                        <el-table-column type="selection" width="55"> </el-table-column>
                        <el-table-column prop="realname" label="姓名" width="120">
                        </el-table-column>

                        <el-table-column
                          prop="sex"
                          label="性别"
                          width="120"
                          show-overflow-tooltip
                        >
                          <template slot-scope="scope">
                            <span v-if="scope.row.sex === 1">男</span>
                            <span v-else-if="scope.row.sex === 2">女</span>
                          </template>
                        </el-table-column>
                        <el-table-column prop="gradeStr" label="年级" width="120">
                        </el-table-column>
                        <el-table-column prop="telephone" label="联系电话" width="150">
                        </el-table-column>
                        <el-table-column prop="email" label="邮箱" width="178">
                        </el-table-column>
                      </el-table>
                    </el-form>
                </el-tab-pane>
                <el-tab-pane label="根据学生排课" name="first">
                  <workOutTeachingSchedule-components v-if="dialogVisible" :dateTime="courses.date" @handleEvent="handleEvent" :categoryIds="categoryId" :ids="studentIds"></workOutTeachingSchedule-components>
                </el-tab-pane>
              </el-tabs>

              <div slot="footer" class="dialog-footer" v-if="activeName !== 'first'" >
                <el-button @click="handleCler" size="small">取 消</el-button>
                <el-button :disabled="showBtns"  type="primary"  size="small"  @click="submitForm(ruleForm)">保存</el-button>
              </div>
            </el-dialog>






            <!-- 日历插件 -->
            <FullCalendar
              ref="fullCalendar"
              class="demo-app-calendar"
              :options="calendarOptions"
            >
              <template v-slot:eventContent="arg">
                <!-- <b>{{ arg.timeText }}</b> -->
                <span>{{arg.event.extendedProps.courseTimeOn}} - {{arg.event.extendedProps.courseEndTime}}</span>
                <span>{{ arg.event.title }}</span>
              </template>
            </FullCalendar>
            <el-dialog
              title="错误提示"
              :visible.sync="dialogTableVisible"
              width="80%"
            >
              <el-table :data="gridData" border>
                <el-table-column prop="date" label="时间"></el-table-column>
                <el-table-column prop="name" label="姓名"></el-table-column>
                <el-table-column prop="role" label="角色"></el-table-column>
                <el-table-column
                  prop="teacherName"
                  label="对应老师"
                ></el-table-column>
                <el-table-column
                  property="categoryName"
                  label="课程"
                ></el-table-column>
                <el-table-column
                  property="detail"
                  label="失败原因"
                ></el-table-column>
              </el-table>
            </el-dialog>
          </div>
        </div>
      </div>
      <el-dialog
        :visible.sync="isHideDetails"
        :show-close="false"
        width="70%"
        :close-on-click-modal="false"
      >
        <schedule-details
          v-if="isHideDetails"
          :childScheduleId="parentScheduleId"
          @childBtnRefresh="childBtnRefresh"
          @childBtnClose="childBtnClose"
          @handleEventEmit="handleEventEmit"
        ></schedule-details>
      </el-dialog>

      <el-dialog
        title="提示"
        append-to-body
        :visible.sync="dialogVisibles"
        width="30%"
        :before-close="handledialogVisibles"
      >
        <el-date-picker
          v-model="courseDate1"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisibles = false, courseDate1 = []">取 消</el-button>
          <el-button type="primary" @click="okTouch">确 定</el-button>
        </span>
      </el-dialog>


      <el-dialog  :title="titleInit" append-to-body :visible.sync="showclassSchedule"   width="50%"  :before-close="handleshowclassSchedule">

        <div style="display: flex; margin-bottom: 30px; margin-top: 40px;">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">日期:</div>
          <div>
            <el-date-picker style="width: 100%;"  value-format="yyyy-MM-dd" v-model="time" type="daterange"  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </div>

        <!-- <div style="display: flex; margin-bottom: 30px;">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">年级:</div>
          <div>
            <el-cascader clearable style="width: 100%;" v-model="gradeLists" :options="gradeList" :props="props"></el-cascader>
          </div>
        </div> -->

        <!-- <div style="display: flex; margin-bottom: 30px;">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">学生状态:</div>
          <div>
            <el-select class="select" filterable  clearable v-model="state" placeholder="请选择学生状态" style="width:100%;">
                <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
                </el-option>
            </el-select>
          </div>
        </div> -->

        <div style="display: flex; margin-bottom: 30px;" v-if="titleInit === '一键删除'">
          <div style="    width: 50%;display: flex;">
            <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">学科:</div>
            <div>
              <el-select v-model="selectedTeacher111"  placeholder="请选择学科" clearable  filterable>
                  <el-option
                    style="margin-left: 10px"
                    v-for="teacher in subjectArr_s"
                    :key="teacher.id"
                    :label="teacher.categoryName"
                    :value="teacher.id">
                  </el-option>
                </el-select>
            </div>
          </div>
        </div>



        <div style="display: flex; margin-bottom: 30px;">
          <div style="    width: 50%;display: flex;">
            <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">教师过滤:</div>
            <div>
              <el-select
                  v-model="selectedTeacher1"
                  placeholder="全部教师"
                  clearable
                  filterable
                >
                  <el-option
                    style="margin-left: 10px"
                    v-for="teacher in teachers"
                    :key="teacher.id"
                    :label="teacher.realname"
                    :value="teacher.id"
                  >
                  </el-option>
                </el-select>
            </div>
          </div>
          <!-- <div style="    width: 50%;display: flex;">
            <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">助理姓名:</div>
            <div>
              <el-select
                  v-model="selectedTeacher2"
                  placeholder="助理姓名"
                  clearable
                  filterable
                >
                  <el-option
                    style="margin-left: 10px"
                    v-for="teacher in teachers1"
                    :key="teacher.id"
                    :label="teacher.realname"
                    :value="teacher.id"
                  >
                  </el-option>
                </el-select>
            </div>
          </div> -->
        </div>

        <div style="display: flex; margin-bottom: 30px;">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">线下学员:</div>
          <div>
            <el-select
              v-model="studentName_s1"
              filterable
              placeholder="请选择线下学员"
              clearable

            >
              <el-option
                style="margin-left: 10px"
                v-for="teacher in studentsList_s"
                :key="teacher.id"
                :label="teacher.realname"
                :value="teacher.id"
              >

              </el-option>
            </el-select>
          </div>
        </div>

        <div style="display: flex; margin-bottom: 30px;">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">规划学员:</div>
          <div>
            <el-select
              v-model="studentName1"
              filterable
              placeholder="请选择规划学员"
              clearable
            >
              <el-option
                style="margin-left: 10px"
                v-for="teacher in studentsList"
                :key="teacher.id"
                :label="teacher.realname"
                :value="teacher.id"
              >

              </el-option>
            </el-select>
          </div>
        </div>

        <div style="display: flex; margin-bottom: 30px;" v-if="titleInit === '一键删除'">
          <div style="padding-top: 10px;margin-right: 20px; width: 60px;text-align: end;">删除原因:</div>
          <div style="width: 80%;">
            <el-input type="textarea" placeholder="请输入内容" :autosize="{ minRows: 6, maxRows: 6 }" v-model="textarea"  maxlength="300"  show-word-limit> </el-input>
          </div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleshowclassSchedule">取 消</el-button>
          <el-button type="primary" @click="handleshowclassScheduleSubt"  v-if="titleInit === '导出课表' || '一键同步'">确 定</el-button>
          <el-button type="primary" @click="handleshowclassScheduleSubt11"  v-if="titleInit === '一键删除'">确 定</el-button>
        </span>
      </el-dialog>


      <el-dialog  :visible.sync="showExportPDF"  width="80%" class="showDing"  :before-close="handleshowExportPDF" :close-on-click-modal="false"  >
        <div style="font-size: 20px;  padding: 10px; font-weight: 900;">
          <span style="margin-right: 10px;" v-if="handlechange1Name">线下学员:{{handlechange1Name}}</span>
          <span style="margin-right: 10px;" v-if="handlechange2Name">规划学员:{{handlechange2Name}}</span>
          <span style="margin-right: 10px;">{{ElEinnerHTML}}</span>
          <span style="margin-right: 10px;">预排课表</span>

          <el-button type="primary" class="btnshowDing" style="height: 27px;  line-height: 3px;  background: #2b3035; border-color: #142f4b;" @click="exportPDF">下载</el-button>

        </div>
        <FullCalendar  ref="fullCalendar"   class="demo-app-calendar" :options="calendarOptionss"  >
           <template v-slot:eventContent="arg">
             <div style="text-align: center; width: 100%; font-weight: 900;font-size: 17px;padding-top: 10px;" :style="{
                color: arg.event.extendedProps.isColor === '数学' ? '#4bd116' : arg.event.extendedProps.isColor === '英语' ? '#0591de' : arg.event.extendedProps.isColor === '语文' ? '#ea5e24' : arg.event.extendedProps.isColor === '政治' ? '#5c19ec' : arg.event.extendedProps.isColor === '地理' ? 'red' : arg.event.extendedProps.isColor === '历史' ? '#1952ec' :  arg.event.extendedProps.isColor === '物理' ? '#e3cc58' :  arg.event.extendedProps.isColor === '化学' ? '#ec1253' : arg.event.extendedProps.isColor === '生物' ? '#7ee57f' : ''
               }">

                <!-- <div>{{arg.event.extendedProps}}</div>  -->

                <div style="text-align: center;">
                   {{ arg.event.extendedProps.S }} ~ {{ arg.event.extendedProps.E }}
                </div>
               <div style="text-align: center;font-size: 20px;" >
                   {{ arg.event.title.substring(2,arg.event.title.length) }}
               </div>
             </div>
           </template>
        </FullCalendar>
      </el-dialog>



      <el-dialog  title="代办" append-to-body  :visible.sync="isShowRepresentative"   width="50%"  :before-close="handleisShowRepresentative">

        <div style="display: flex;flex-wrap: wrap;">
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;" v-if="isShowRepresentativeObj.toDoTeacherType === 1">学生(老师)：{{ isShowRepresentativeObj.studentName }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;" v-else>学生：{{ isShowRepresentativeObj.studentName }}</div>
          
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">老师：{{ isShowRepresentativeObj.teacherName }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">截止时间：{{ isShowRepresentativeObj.courseDate }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">截止开始时间：{{ isShowRepresentativeObj.courseTimeOn }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">截止结束时间：{{ isShowRepresentativeObj.courseEndTime }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">任务名称：{{ isShowRepresentativeObj.courseName }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">任务详情：{{ isShowRepresentativeObj.taskDetail }}</div>
          <div style="width: 30%;margin-right: 10px;margin-bottom: 20px;margin-left: 10px;margin-top: 20px;">任务创建人：{{ isShowRepresentativeObj.taskUserName }}</div>
        </div>

        <span slot="footer" class="dialog-footer">
          <el-button @click="handleisShowRepresentative">取 消</el-button>
        </span>
      </el-dialog>


    </div>
</template>

  <script>
  import axios from "axios";
  import { EventBus } from "../assets/js/event";
  import apiBaseUrl from "../../config/api";
  import FullCalendar from "@fullcalendar/vue";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import timeGridPlugin from "@fullcalendar/timegrid";
  import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
  import zhcn from "@fullcalendar/core/locales/zh-cn"; //中文
  import scheduleDetails from "./ScheduleDetails.vue"; //排课弹窗详情
  import { normalizeUnits } from "moment";
  import moment from "moment";
  import { dA } from "@fullcalendar/core/internal-common";
  import workOutTeachingScheduleComponents from "./workOutTeachingSchedule-components.vue";
  import loadingUtils from "../utils/loading";
  import { getSubject,} from "@/api/firstClassApi";
  import jsPDF from 'jspdf';
  import html2canvas from 'html2canvas';



  // import { INITIAL_EVENTS, createEventId } from './event-utils'
  export default {
    components: {
      FullCalendar, // make the <FullCalendar> tag available
      scheduleDetails,
      'workOutTeachingSchedule-components':workOutTeachingScheduleComponents,
    },
    mounted() {

      axios.get(`${apiBaseUrl}/category/one`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }) .then(res => {
          if(res.data.code === 200){
              if(res.data.data && res.data.data.length > 0){
                this.optionList5 = res.data.data
              }else{
                this.optionList5 = []
              }
          }else{
            this.optionList5 = []
            this.$message.error(res.data.message)
          }
          }).catch(error => {
            this.$message.error(error)
      })


       getSubject().then((res) => { this.subjectArr_s = res.data; })
       axios.get(`${apiBaseUrl}/grade/getGrade`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then(res => {
            if (res.data.data.length > 0) {
              this.gradeList = res.data.data;
            } else {
              this.$message({
                message: "获取年级列表失败",
                type: "error"
              });
            }
          })
          .catch(error => {
            console.log(error);
      })

      axios.get(`${apiBaseUrl}/schedule/assistantList`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
           .then(response => {
             let param = {
               realname: "",
               id: ""
             }

             this.teachers1 = response.data.data

           })
           .catch(error => {
             console.error(error);
           });

      axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
           .then(response => {
             let param = {
               realname: "全部老师",
               id: ""
             }
             this.teachers = [param, ...response.data.data]


           })
           .catch(error => {
             console.error(error);
           });
      axios.get(`${apiBaseUrl}/schedule/categorylist/${1}`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }).then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.courses = data.data
            // sessionStorage.setItem("categorylist_Jons", JSON.stringify(data.data));
          }
        });
      //  规划学生 studentType：1
      axios
        .post(`${apiBaseUrl}/student/getStudentList`, {
          studentType: 1,
        },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
        .then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.studentsList = data.data
            sessionStorage.setItem(
              "getStudentList_Jons",
              JSON.stringify(data.data)
            );
          }
        });
      // 线下学生 studentType：2
      axios.post(`${apiBaseUrl}/student/getStudentList`, {studentType: 2, },{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  } }).then((res) => {
          let { data } = res;
          if (data.code == 200) {
            this.studentsList_s = data.data
            sessionStorage.setItem("getStudentList_Jons_s",  JSON.stringify(data.data)  );
          }
        });

      let containerEl = document.getElementById("external-events");
      new Draggable(containerEl, {
        itemSelector: ".fc-event",
        eventData: function (eventEl) {
          //自定id
          let eventId = eventEl.querySelector(".fcevent").getAttribute("data-id");

          return {
            title: eventEl.innerText,
            id: eventId,
          };
        },
      });

      this.jsonShow = false;
      this.renderShow = false;
      this.listdate();

      // 重写 今天按钮
      const Dom = document.getElementsByClassName("fc-today-button")[0];
      Dom.addEventListener("click", (e) => {
        e.preventDefault();
        this.jsonShow = false;
        this.renderShow = false;
        this.listdate();
      });




      // let ele = document.getElementsByClassName('showDing')[0]
      // ele.style.height = '10px'
      // ele.style.opacity = '0'
    },
    data: function () {
      return {
        optionList5:[],
        isShowRepresentative: false,
        isShowRepresentativeObj:{},
        subjectArr_s:[],
        selectedTeacher111:'',
        textarea:'',
        activeName: 'second',
        ClassType:1,
        // classPersonTypeList1:[ {id:1,name:'1v1'}, {id:2,name:'1v2'}, {id:3,name:'1v3'},],
        classPersonTypeList1:[],
        showExportPDF:false,
        handlechange1Name:'',
        handlechange2Name:'',
        ElEinnerHTML:'',
        state:'',
        classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' },{ value: 4, label: '流失' }],
        classPersonType:1,
        classPersonTypeList:[{id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'}, ],
        // classPersonTypeList:[
          // {id:1,name:'孩子'},
          // {id:2,name:'孩子和父亲'},
          // {id:3,name:'孩子和母亲'},
          // {id:4,name:'父亲'},
          // {id:5,name:'母亲'},
          // {id:6,name:'父亲和母亲'},
          // {id:7,name:'孩子、父亲、母亲'},
        // ],
        gradeList: [],
        gradeLists:[],
        props: {
          label: "gradeName",
          children: "children",
          value: "id"
        },
        teachers1:[],
        selectedTeacher1:'',
        studentName_s1:'',
        studentName1:'',
        showBtns:false,
        gridData: [],
        dialogTableVisible: false,
        file: `${apiBaseUrl}/schedule/import`,
        isHideDetails: false,
        time: [],
        num: 0,
        educationType: '', //教育类型
        relativeTime: "4", //自定义
        isFirst: 2,
        relativeTimes: [
          {
            value: "1",
            label: "每天",
          },
          {
            value: "2",
            label: "每周",
          },
          {
            value: "3",
            label: "自定义",
          },
          {
            value: "4",
            label: "无",
          },
        ],
        categoryId: "", //课程类型ID
        checkList: [],
        id1: "",
        teachers: [], //下拉框默认值
        query: "", // 查询关键字
        courses: [], //拖拽课程
        studentIds: [],
        counter: "",
        startTime: "", // 开始时间变量
        endTime: "", // 结束时间变量
        startTime1: "",
        endTime1: "",
        selectedTeacher2:'',
        courseId: null,
        courseScheduleData: null, //存储回显的排课信息数据
        studentList: [], // 存储学生列表数据的变量
        selectedTeacher: null, // 如果需要预先选中某个选项，可以在这里设置默认值
        dialogVisible: false, // 控制弹层显示状态的数据属性
        ruleForm: {
          startTime: "",
          endTime: "",
          selectedTeacher: "",
        },
        // teacherId:this.ruleForm.selectedTeacher,
        rules: {
          startTime: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
          endTime: [
            { required: true, message: "请选择结束时间", trigger: "blur" },
            { validator: this.checkEndTime, trigger: "change" },
          ],
          selectedTeacher: [
            { required: true, message: "请选择教师", trigger: "change" },
          ],
        },
        calendarOptions: {
          handleWindowResize: true,
          eventColor: this.getEventColor, // 使用方法来确定颜色
          firstDay: 1,
          allDaySlot: false, // 不显示all-day
          firstHour: 6,
          slotMinTime: "06:00:00",
          slotMaxTime: "24:00:00",
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin, // needed for dateClick
          ],
          datesSet: this.handleDatesSet,
          headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          },

          /* 设置按钮文字 */
          buttonText: {
            today: "今天",
            dayGridMonth: "月",
            timeGridWeek: "周",
            timeGridDay: "日",
          },
          locale: "zh-cn",
          // dayGridMonth, timeGridWeek,timeGridDay
          initialView: "dayGridMonth",
          // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          // handleViewRender,
          eventDidMount: function (info) {


            if (info.event.extendedProps.isClassType === 2) {
                info.el.style.background = "#3788d8";
                // info.el.style.color = "#fff";
            }

            if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
                 info.el.style.background = "#6ced62";
            }

            if (info.event.extendedProps.isShowbgcColor) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            } else {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "#3788d8";
              }
            }
            if (
              info.event.extendedProps.classEnding == 1 &&
              info.event.extendedProps.isFirst !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "orange";
                info.el.style.borderColor = "orange";
              }

            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding == 1
            ) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "#E380E3";
              info.el.style.borderColor = "#E380E3"
              }
            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "#54bcbd";
              info.el.style.borderColor = "#54bcbd";
              }
            }
             if ( info.event.extendedProps.isPreScheduled === 1 ) {
                 info.el.style.background = "rgb(235 82 20)";
                 info.el.style.borderColor = "rgb(38 216 217)";
                 if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    // info.el.style.color = "#fff";
                 }
             }
             if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    // info.el.style.color = "#fff";
             }

            if(info.event.extendedProps.ISTIMERED === 1){
              info.el.style.background = "#e10909";
              info.el.style.borderColor = "#e10909";
              info.el.style.pointerEvents = "none";
              info.el.style.cursor = "not-allowed";
            }     

             if(info.event.extendedProps.isShowbgcColor && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "darkgray";
                  info.el.style.color = "#000";
              }

              if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "#6ced62";
                  info.el.style.color = "#000";
              }

          }, //事件挂载
          events: [],
          customButtons: {
            next: {
              click: this.nextClick,
            },
            prev: {
              click: this.prevClick,
            },
          },
          eventColor: function (event) {
            if (event.start.isBefore(new Date())) {
              return "f0f0f0"; // 过去事件的背景颜色
            } else {
              return "#008000"; // 未来事件的背景颜色
            }
          },

          // select: this.handleDateSelect,
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents,
          /* you can update a remote database when these fire:
          eventAdd:
          eventChange:
          eventRemove:
          */
        },
        calendarOptionss: {
          handleWindowResize: true,
          eventColor: this.getEventColor1, // 使用方法来确定颜色
          firstDay: 1,
          allDaySlot: false, // 不显示all-day
          firstHour: 6,
          slotMinTime: "06:00:00",
          slotMaxTime: "24:00:00",
          plugins: [
            dayGridPlugin,
            timeGridPlugin,
            interactionPlugin, // needed for dateClick
          ],
          datesSet: this.handleDatesSet,
          headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          },

          /* 设置按钮文字 */
          buttonText: {
            today: "今天",
            dayGridMonth: "月",
            timeGridWeek: "周",
            timeGridDay: "日",
          },
          locale: "zh-cn",
          // dayGridMonth, timeGridWeek,timeGridDay
          initialView: "dayGridMonth",
          // initialEvents: INITIAL_EVENTS, // alternatively, use the `events` setting to fetch from a feed
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          // handleViewRender,
          eventDidMount: function (info) {

            // if (info.event.extendedProps.isbgcColors === 1) {
            //     info.el.style.background = "#2a84e8";
            // }
            if (info.event.extendedProps.isClassType === 2) {
                info.el.style.background = "#3788d8";
                info.el.style.color = "#fff";
            }

            if(info.event.extendedProps.ISTIMERED === 1){
               info.el.style.background = "#e10909";
               info.el.style.borderColor = "#e10909";
               info.el.style.pointerEvents = "none";
               info.el.style.cursor = "not-allowed";
            }

            if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
                 info.el.style.background = "#6ced62";
            }

            if (info.event.extendedProps.isShowbgcColor) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            } else {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            }
            if (
              info.event.extendedProps.classEnding == 1 &&
              info.event.extendedProps.isFirst !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
                info.el.style.borderColor = "darkgray";
              }

            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding == 1
            ) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              info.el.style.borderColor = "darkgray"
              }
            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              info.el.style.borderColor = "darkgray";
              }
            }
             if ( info.event.extendedProps.isPreScheduled === 1) {
              info.el.style.background = "rgb(235 82 20)";
              info.el.style.borderColor = "rgb(38 216 217)";
              if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    // info.el.style.color = "#fff";
                 }
             }
             if(info.event.extendedProps.isShowbgcColor && info.event.extendedProps.isClassType === 2){
              info.el.style.background = "darkgray";
              info.el.style.color = "#000";
          }

          if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
              info.el.style.background = "#6ced62";
              info.el.style.color = "#000";
          }

          }, //事件挂载
          events: [],
          customButtons: {
            next: {
              click: this.nextClick,
            },
            prev: {
              click: this.prevClick,
            },
          },
          eventColor: function (event) {
            if (event.start.isBefore(new Date())) {
              return "f0f0f0"; // 过去事件的背景颜色
            } else {
              return "#008000"; // 未来事件的背景颜色
            }
          },

          // select: this.handleDateSelect,
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents,
          /* you can update a remote database when these fire:
          eventAdd:
          eventChange:
          eventRemove:
          */
        },
        pickerOptions: {
          shortcuts: [
            {
              text: "最近一周",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近一个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
              },
            },
            {
              text: "最近三个月",
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
              },
            },
          ],
        },
        value1: "", //日期绑定
        value2: "",
        currentEvents: [],
        lockLoading: false,
        btnInitialViewSelect: "",
        loadingFalg: false,
        monStatus: "",
        satNum: "",
        sunNum: "",
        address: "",
        studentName: "",
        studentName_s: "",
        studentsList: [],
        studentsList_s: [],
        timeTeachers: [],
        parentScheduleId: "",
        jsonShow: true,
        dialogVisibles: false,
        courseDate1: [], //一键结课日期
        renderShow: false,
        eventBtn: false,
        listJsonString: "",
        showclassSchedule:false,
        titleInit:'',
        copyList:[],
        tabPosition: 'xueyeke',

        STATR_TIME:'',
        END_TIME:'',
        DATALISTALL:[],

        DATALISTALL1:[],
        DATALISTALL2:[],
        DATALISTALL3:[],

        disabledOptions:[],
        isdisabled1: false,
        isdisabled2: false,
        isdisabled3: false,

      };
    },
    created() {
      // this.fetchTeachers();
      // this.fetchCourses();
      // // this.listdate();
      // // this.getCurrentDate();
      // // 获取学生
      // this.getStudenList();
    },
    beforeRouteLeave(to, from, next) {
      if (to.name !== "ScheduleDetails") {
        from.meta.keepAlive = false;
      } else {
        from.meta.keepAlive = true;
      }
      next();
    },
    // watch: {
    //   '$route' () {
    //     this.listdate(); //我的初始化方法
    //   }
    // },
    methods: {

      handleDateChange(){
         if(this.courses.date){
            if(this.ruleForm.selectedTeacher){
               let data = { courseDate: this.courses.date, teacher_id: this.ruleForm.selectedTeacher}
               axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                    if(res.data.data && res.data.data.length > 0){
                      let len = res.data.data[0]
                      this.$message.warning(len)
                    }
                } else {
                  this.$message.error('请联系管理员~');
                }
              }).catch(err => {
                this.$message.error(err,'请联系管理员~');
              })
            }
        }
      },

      handleGetTeacher(){
        if(this.courses.date){
            if(this.ruleForm.selectedTeacher){
               let data = { courseDate: this.courses.date, teacher_id: this.ruleForm.selectedTeacher }
               axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                if (res.data.code === 200) {
                    if(res.data.data && res.data.data.length > 0){
                      let len = res.data.data[0]
                      this.$message.warning(len)
                    }
                } else {
                  this.$message.error('请联系管理员~');
                }
              }).catch(err => {
                this.$message.error(err,'请联系管理员~');
              })
            }
        }
      },

      changeBanXing(){
          this.handleGetgetClassTypeTeacher()
      },

      handleGetgetClassTypeTeacher(){
         let data = { categoryId: this.categoryId, productClassType: this.ClassType ? this.ClassType : 1 };
         axios.post(`${apiBaseUrl}/preScheduled/getClassTypeTeacher`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
             if(res.data.code === 200){
                let data = res.data.data
                if(data && data.length > 0){
                   this.timeTeachers = data
                }else{
                   this.timeTeachers = []
                }
             }
         });
      },

      handleClickTba(e){

        if(e.id){
          this.listdate()
          axios.get(`${apiBaseUrl}/schedule/categoryChildren/${e.id}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
              if(res.data.code === 200){
                  if(res.data.data && res.data.data.length > 0){
                    this.courses = res.data.data
                  }else{
                    this.courses = []
                  }
              }else{
                this.courses = []
                this.$message.error(res.data.message)
              }
              }).catch(error => {
                this.$message.error(error)
          })
        }

        // if(e === 'xueyeke'){
        //   this.listdate()
        //   axios.get(`${apiBaseUrl}/schedule/categorylist/${1}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
        //       let { data } = res;
        //       if (data.code == 200) {
        //         this.courses = data.data
        //       }
        //   })
        // }
        // if(e === 'jiatingke'){
        //   this.listdate()
        //   axios.get(`${apiBaseUrl}/schedule/categorylist/${2}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
        //       let { data } = res;
        //       if (data.code == 200) {
        //         this.courses = data.data
        //       }
        //   })
        // }
        // if(e === 'zhenduanke'){
        //   this.listdate()
        //   axios.get(`${apiBaseUrl}/schedule/categorylist/${3}`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res) => {
        //       let { data } = res;
        //       if (data.code == 200) {
        //         this.courses = data.data
        //       }
        //   })
        // }
      },

      handleDelete(){
          this.titleInit = '一键删除'
          this.showclassSchedule = true
      },
      handleClicktab(tab, event){
        if(tab.index === '1'){
          this.$message({  message: '只能选择一个学员~', type: "warning" });
        }
      },

      handlechange1(e){
        this.handlechange1Name = e
      },
      handleclear1(e){
        this.handlechange1Name = ''
      },
      handleclear2(e){
        this.handlechange2Name  = ''
      },
      handlechange2(e){
        this.handlechange2Name = e
      },
      handledialogVisibles(){
        this.dialogVisibles = false
        this.courseDate1 = []
      },
      handleCler() {
        this.dialogVisible = false;
        this.ruleForm.startTime = "";
        this.ruleForm.endTime = "";
        this.ruleForm.selectedTeacher = "";
        this.studentIds = [];
        this.educationType = 2;
        this.isFirst = 2;
        this.classPersonType = ''
        this.relativeTime = "4";
        this.activeName = 'second'
        this.ClassType = ''
      },
      //导入课表
      handleSuccess(response, file, fileList) {
        if (response.code == 200) {
          this.$message.success(response.message);
          this.listdate();
        } else {
          if (response.message.length < 20) {
            this.$message.error(response.message);
          } else {
            this.dialogTableVisible = true;
            this.gridData = JSON.parse(response.message);
            // var array = []
            // for (let i in msgList) {
            //   array.push('时间:' + msgList[i].date + '姓名:' + msgList[i].name + '角色:' + msgList[i].role + '对应老师:' + msgList[i].teacherName + '课程:' + msgList[i].categoryName + '失败原因:' + msgList[i].detail + '<br/>')
            // }
            // let list = array.join('')
            // this.$message({
            //   dangerouslyUseHTMLString: true,
            //   message: list,
            //   type: 'error'
            // })
          }
        }
      },
      btnSchedule() {
        let list = [];
        if (this.studentName) {
          list.push(this.studentName);
        }
        if (this.studentName_s) {
          list.push(this.studentName_s);
        }
        let listJsonString = list.join(",");
        this.listJsonString = listJsonString;
        this.listdate();
        // if (this.studentName) {
        //   this.getStudenList()
        //   .post(`${apiBaseUrl}/schedule/getStudentSchedule`, data)
        //   .then(res => {
        //     console.log(res.data.data);
        //     this.studentsList = res.data.data
        //   })
        // }
      },


      handleisShowRepresentative(){
        this.isShowRepresentative = false
      },


      getStudenList() {
        if (this.selectedTeacher) {
          let data = {
            teacherId: this.selectedTeacher,
          };
          axios.post(`${apiBaseUrl}/teacher/getStudentList`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }).then((res) => {
            this.studentsList = res.data.data && res.data.data.data ? res.data.data.data : [];
          });
        } else {

          // axios
          //   .get(`${apiBaseUrl}/student/getStudentList`)
          //   .then(res => {
          //     this.studentsList = res.data.data
          //   })
        }
          // let selectschedule_Jons = JSON.parse(
          //   sessionStorage.getItem("getStudentList_Jons")
          // );
          // this.studentsList = selectschedule_Jons;
          // let selectschedule_Jons_s = JSON.parse(
          //   sessionStorage.getItem("getStudentList_Jons_s")
          // );
          // this.studentsList_s = selectschedule_Jons_s;
      },
      childBtnRefresh() {
        this.isHideDetails = false;
        this.listdate();
      },

      handleblur(){

        axios.post(`${apiBaseUrl}/preScheduled/getClassType`, { categoryId: this.categoryId, studentId:  '[' + this.studentIds + ']' },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
           let data = res.data.data
           if(data && data.length > 0){
              data.forEach((itme)=>{
                 itme.id = itme.classType
                 itme.name = itme.classType === 1 ? '1v1' : itme.classType === 2 ? '1v2' : itme.classType === 3 ? '1v3' : '1v3'
              })

              this.classPersonTypeList1 = data

           }else{
              this.classPersonTypeList1 =[]
              this.ClassType = ''
              this.classPersonType = ''
           }
        })

      },

      childBtnClose(val) {
        this.jsonShow = false;
        this.renderShow = false;
        this.listdate();
        this.isHideDetails = false;
        this.eventBtn = false;
        // if (val) {
        //   this.listdate()
        // } else {
        //   if (this.btnInitialViewSelect == "dayGridMonth") {
        //     this.calendarOptions.initialView = this.btnInitialViewSelect ? this.btnInitialViewSelect : this.calendarOptions.initialView
        //     this.$nextTick(() => {
        //       this.getoptionList()
        //       this.getListAssembly(JSON.parse(window.sessionStorage.getItem("eventsList")))
        //     })
        //   }
        // }
      },
      clean(val) {
        if (val == "start") {
          this.diagnosisOff.startTimeHour = "";
        } else {
          this.diagnosisOff.endTimeHour = "";
        }
      },
      //获取当前日期
      getCurrentDate() {
        // this.time = this.getTimeDay(new Date());
      },
      getTimeDay(date) {
        var year = date.getFullYear();
        var month = date.getMonth() + 1;
        var day = date.getDate();
        if (month < 10) {
          month = "0" + month;
        }
        if (day < 10) {
          day = "0" + day;
        }
        var currentdate = year + "-" + month + "-" + day;
        return currentdate;
      },

       exportPDF() {
        // let ele = document.getElementsByClassName('fc-view-harness fc-view-harness-active')[0]

        // let ele = document.getElementsByClassName('showDing')[0]
        // let eleCh = document.getElementsByClassName('fc-dayGridMonth-view fc-view fc-daygrid')[0]
        // const h4Element = document.createElement('h4');
        // h4Element.textContent = '排课信息';
        // h4Element.style.fontSize = '20px'
        // h4Element.style.textAlign = 'center'
        // h4Element.style.marginTop = '-45px'
        // eleCh.insertAdjacentElement('beforebegin', h4Element);



        this.$nextTick(()=>{

            let eleShow = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr')[1]
            eleShow.style.opacity = '0'
            let eleShow1 = document.getElementsByClassName('btnshowDing')[0]
            eleShow1.style.opacity = '0'

          // let ele = document.getElementsByClassName('fc-view-harness fc-view-harness-active')[0]



          let ele = document.getElementsByClassName('showDing')[0]
          if (ele) {
              html2canvas(ele).then((canvas) => {
                  const imgData = canvas.toDataURL('image/jpg')
                  const doc = new jsPDF({ orientation: 'portrait', unit: 'px', format: 'a4' })
                  const imgProps = doc.getImageProperties(imgData)
                  const pdfWidth = doc.internal.pageSize.getWidth()
                  const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width

                  const x = (pdfWidth - 100) / 2
                  const y = (pdfHeight - 100) / 2

                  doc.addImage(imgData, 'PNG', 0, y, pdfWidth, pdfHeight)



                  doc.save('预排课表.pdf')
                  let eleShow = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr')[1]
                  eleShow.style.opacity = '1'
                  let eleShow1 = document.getElementsByClassName('btnshowDing')[0]
                  eleShow1.style.opacity = '1'

              })
          } else {
              loadingUtils.endLoading();
              console.error('Element is not attached to a Document');
          }
        })


      },


      handleSynchronization(){
        this.titleInit = '一键同步'
        this.showclassSchedule = true

      },

      handleRevoke(){
        this.titleInit = '一键撤销'
        this.showclassSchedule = true

      },

      handleRevokes(type){
        let data = { scheduleId: this.scheduleId }
        axios.put(`${apiBaseUrl}/${type === '同步' ? 'preScheduled/syncOne' : 'preScheduled/quashOne' }`, data, { headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
            if(res.data.code === 200){
              this.$message({  message: res.data.msg, type: "success", });
            }else{
              this.$message({  message: res.data.msg, type: "error", });
            }
        });
      },

      classSchedule(){
        this.titleInit = '导出课表'
        this.showclassSchedule = true
        // this.showExportPDF = true

        // // let eles = document.getElementsByClassName('showDing')[0]
        // // eles.style.height = '100%'
        // // eles.style.opacity = '1'
        // this.getoptionList()
        // this.getListAssembly(this.copyList)




        // this.$nextTick(()=>{


        //   let mianELE = document.querySelectorAll('.fc-event-main')
        //   mianELE.forEach((itme)=>{
        //      itme.style.paddingTop = '10px'
        //   })

        //   const Dom1 = document.getElementsByClassName("fc-today-button")[1];
        //   Dom1.addEventListener("click", (e) => {
        //     e.preventDefault();
        //     this.jsonShow = false;
        //     this.renderShow = false;
        //     this.listdate();
        //   });

        //   // let ele = document.getElementsByClassName('fc-toolbar-title')[0]
        //   // setInterval(()=>{
        //       let ele = document.getElementsByClassName('fc-toolbar-title')[0]

        //       if( ele && ele.innerHTML){
        //          this.ElEinnerHTML = ele.innerHTML
        //       }else{
        //         setInterval(()=>{
        //           console.log(ele)
        //           let ele1 = document.getElementsByClassName('fc-toolbar-title')[1]
        //           if( ele1 && ele1.innerHTML){
        //             this.ElEinnerHTML = ele1.innerHTML
        //           }
        //         },1500)
        //       }
        //   // },1000)

        //   // let eleShow = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr')[1]
        //   // eleShow.style.display = 'none'
        // })

        // this.exportPDF()
      },
      handleshowclassSchedule(){
        this.state = ''
        this.titleInit = ''
        this.gradeLists = []
        this.time = []
        this.selectedTeacher111 = ''
        this.textarea = ''
        this.selectedTeacher1 = ''
        this.selectedTeacher2 = ''
        this.studentName_s1 = ''
        this.studentName1 = ''

        this.showclassSchedule = false
      },
      handleshowclassScheduleSubt(){
        this.classSchedule1()

      },

        //导出课表按钮
        classSchedule1() {

        let str =''
        if(this.studentName_s1){
          str = this.studentName_s1 + ''
          if(this.studentName1){
            str = this.studentName_s1 + ',' + this.studentName1 + ''
          }
        }
        else if(this.studentName1){
          str = this.studentName1 + ''
        }else{
          str =  ''
        }


        const data = {
          startTime: this.time.length > 0 ? this.time[0] : '',
          endTime: this.time.length > 0 ? this.time[1] : '',
          teacherId: this.selectedTeacher1,
          // assistantId: this.selectedTeacher2,
          studentId: str,
          // grade: this.gradeLists.length > 0 ? JSON.stringify(this.gradeLists) : '',
          // state: this.state,
        };

        let api = 'preScheduled/syncData'
        let api1 = 'preScheduled/quashData'

        if(this.titleInit === '导出课表'){
          axios.post(`${apiBaseUrl}/preScheduled/exportSchedule`, data, { responseType: "blob", headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
            if(res.status === 200){

                const blob = new Blob([res.data], {  type: "application/vnd.ms-excel",  });
                const downloadLink = document.createElement("a");
                downloadLink.href = URL.createObjectURL(blob);
                downloadLink.download = "排课课表.xlsx";
                downloadLink.click();
                this.handleshowclassSchedule()
              }else{
                this.$message({  message: '参数校验错误', type: "error", });
              }

          });
        }else{
          let datas = {
              startTime: this.time.length > 0 ? this.time[0] : '',
              endTime: this.time.length > 0 ? this.time[1] : '',
              teacherId: this.selectedTeacher1 + '',
              studentIds: str,
          }
          axios.put(`${apiBaseUrl}/preScheduled/syncData`, datas, { headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
            if(res.data.code === 200){
                this.$message({  message: res.data.message, type: "success", });
                this.handleshowclassSchedule()
              }else{
                this.$message({  message: res.data.message, type: "error", });
              }

          });
        }
      },

      addTwoHours(currentHours, currentMinutes) {
        var now = new Date();
        now.setHours(currentHours, currentMinutes, 0, 0); // 分钟和秒都设为0
        // 在当前时间基础上加上2小时
        now.setHours(now.getHours() + 2);
        // 返回格式化的时间字符串，例如 "HH:MM"
        return now.getHours() + ':' + now.getMinutes().toString().padStart(2, '0');
      },


      //
      startTimeSelect(val, row) {

        if (val == "start") {
            this.ruleForm.startTime = row;
            let s = this.ruleForm.startTime.substring(0, 2)
            let d = this.ruleForm.startTime.substring(3, 5)
            this.ruleForm.endTime = this.addTwoHours(s, d)
        } else {
            this.ruleForm.endTime = row;
        }
      },
      // 根据课程类型获取 所有学生
      getAllStudents() {
        const data = {
          categoryId: this.categoryId,
          ids: [],
        };
        axios
          .post(`${apiBaseUrl}/student/getStudentByCategoryId`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((res) => {
            this.studentList = res.data.data;
          });
      },
      handleChange() {},
      nextClick() {
        this.jsonShow = false;
        let calendarApi = this.$refs["fullCalendar"].getApi();
        calendarApi.next();
        this.startTime1 = this.aa(calendarApi.view.activeStart);
        this.endTime1 = this.aa(calendarApi.view.activeEnd);
        let dateFormat = new Date(this.endTime1);
        dateFormat = dateFormat.setDate(dateFormat.getDate() - 1);
        dateFormat = new Date(dateFormat);
        let y = dateFormat.getFullYear();
        let m = (dateFormat.getMonth() + 1).toString().padStart(2, "0");
        let d = dateFormat.getDate().toString().padStart(2, "0");
        this.endTime1 = y + "-" + m + "-" + d;
        // 转时间戳比较
        // let timeStar = Date.parse(new Date(calendarApi.view.activeStart));
        // let timeEnd = Date.parse(new Date(calendarApi.view.activeEnd));
        // if (timeEnd - timeStar < 864000000) { // 小于10天，进行数据封装
        //   console.log('进来')
        //   const firstDay = new Date(new Date(this.startTime1).getFullYear(), new Date(this.startTime1).getMonth(), 1); // 获取当前月的第一天
        //   const lastDay = new Date(new Date(this.endTime1).getFullYear(), new Date(this.endTime1).getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天
        //   this.startTime1 = this.formatConvert(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() - 7)) // 前7天
        //   this.endTime1 = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 11))      // 后七天
        // }
        // console.log(this.startTime1,'开始');
        // console.log(this.endTime1, '结束');
        this.listdate(1);
      },
      getReplace(timeVal, num) {
        let time = timeVal;
        let arr = time.split("-");
        console.log(arr);
        arr[2] = num;
        time = arr.join("-");
        return time;
      },
      getReturnDate(val) {
        const date = new Date(val);
        const year = date.getFullYear();
        const month = date.getMonth() + 1; // 月份从0开始计算，需要加1
        const lastDay = new Date(year, month, 0).getDate();
        return this.getReplace(val, lastDay);
      },
      prevClick() {
        this.jsonShow = false;
        let calendarApi = this.$refs["fullCalendar"].getApi();
        calendarApi.prev();

        this.startTime1 = this.aa(calendarApi.view.activeStart);
        this.endTime1 = this.aa(calendarApi.view.activeEnd);

        console.log(this.aa(calendarApi.view.activeStart), "开始时间");
        console.log(this.aa(calendarApi.view.activeEnd), "结束时间");

        let dateFormat = new Date(this.endTime1);
        dateFormat = dateFormat.setDate(dateFormat.getDate() - 1);
        dateFormat = new Date(dateFormat);
        let y = dateFormat.getFullYear();
        let m = (dateFormat.getMonth() + 1).toString().padStart(2, "0");
        let d = dateFormat.getDate().toString().padStart(2, "0");
        this.endTime1 = y + "-" + m + "-" + d;
        // 转时间戳比较
        // let timeStar = Date.parse(new Date(calendarApi.view.activeStart));
        // let timeend = Date.parse(new Date(calendarApi.view.activeEnd));
        // if (timeend - timeStar < 864000000) { // 小于10天，进行数据封装
        //   const firstDay = new Date(new Date(this.startTime1).getFullYear(), new Date(this.startTime1).getMonth(), 1); // 获取当前月的第一天
        //   const lastDay = new Date(new Date(this.endTime1).getFullYear(), new Date(this.endTime1).getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天
        //   this.startTime1 = this.formatConvert(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() - 7))
        //   this.endTime1 = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 11))
        // }
        // console.log(this.startTime1);
        this.listdate(0);
      },
      techerBtnList(val) {
        if (val) {
          // let params = {
          //   courseDate: this.courses.date.slice(0, 10),
          //   courseTimeOn: this.ruleForm.startTime,
          //   courseEndTime: this.ruleForm.endTime,
          //   categoryId: this.categoryId,
          // };
          // axios.post(`${apiBaseUrl}/schedule/getTeacherList`, params,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res) => {
          //     console.log(res);
          //     this.timeTeachers = res.data.data;
          // });

          let data = {
              categoryId: this.categoryId,
              productClassType: this.ClassType ? this.ClassType : 1,
              courseDate: this.courses.date.slice(0, 10),
              courseTimeOn: this.ruleForm.startTime,
              courseEndTime: this.ruleForm.endTime,
              categoryId: this.categoryId,
              studentId: '[' + this.studentIds + ']'
          };
          axios.post(`${apiBaseUrl}/preScheduled/getClassTypeTeacher`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
              if(res.data.code === 200){
                  let data = res.data.data
                  if(data && data.length > 0){
                    this.timeTeachers = data
                  }else{
                    this.timeTeachers = []
                  }
              }
          });

        }




        let datas = { teacherId: this.ruleForm.selectedTeacher, categoryId: this.categoryId, studentId: '[' + this.studentIds + ']'  };
        axios.post(`${apiBaseUrl}/schedule/calibrationProduct`, datas,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then((res) => {
              if(res.data.code === 200 || res.data.code === 1){
                  let data = res.data.data
                  this.isdisabled1 = data.onlineClasses 
                  this.isdisabled2 = data.onsite 
                  this.isdisabled3 = data.stores
              }else{
                this.$message.error(res.data.msg || res.data.message)
              }
        }).catch(err => {
          this.$message.error(err)
        })

      },


      handleClick(id) {
        const data = {
          categoryId:   this.categoryId,
          teacherId: id,
          ids: [],
        };
        axios.post(`${apiBaseUrl}/student/getStudentByCategoryId`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((res) => {
            this.studentList = res.data.data;
          });
        this.fetchStudents();
        // this.handleGetTeacher()
      },
      // 检查结束时间是否大于开始时间
      checkEndTime(rule, value, callback) {
        if (value === this.ruleForm.startTime) {
          callback(new Error("结束时间不能和开始时间相同"));
        } else {
          callback();
        }
      },
      getEventColor(event) {
        const now = new Date();
        const eventStart = new Date(event.start);

        if (eventStart < now) {
          return "gray"; // 如果事件已经开始，返回灰色
        } else {
          return ""; // 如果事件还未开始，返回空字符串，使用组件自带颜色
        }

      },

      handleshowclassScheduleSubt11(){

        let str =''
        if(this.studentName_s1){
          str = this.studentName_s1 + ''
          if(this.studentName1){
            str = this.studentName_s1 + ',' + this.studentName1 + ''
          }
        }
        else if(this.studentName1){
          str = this.studentName1 + ''
        }else{
          str =  ''
        }

        let admin = JSON.parse(localStorage.getItem('admin'))

        const data = {
            startDate: this.time.length > 0 ? this.time[0] : '',
            endDate: this.time.length > 0 ? this.time[1] : '',
            teacherId: this.selectedTeacher1,
            studentIds: str,
            categoryId: this.selectedTeacher111,
            deleteCause: this.textarea,
            delPersonId: admin.id
        };


        axios.post(`${apiBaseUrl}/preScheduled/delData`, data, { headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
           if(res.data.code === 200){
              this.$message({  message: res.data.message, type: "success", });
              this.listdate();
              this.showclassSchedule = false
              this.handleshowclassSchedule()
            }else{
              this.$message({  message: res.data.message, type: "error", });
            }

        });
      },

          
      handlequeryScheduleTeacherLeave(){
         axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryScheduleTeacherLeave`, {
           start_time: this.STATR_TIME,
           end_time: this.END_TIME,
           teacher_id: this.selectedTeacher,
         },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')  }}).then((res) => {
           let datas = res.data.data;
           this.DATALISTALL1 = datas.compensate ? datas.compensate : []
           this.DATALISTALL2 = datas.staff_leave ? datas.staff_leave : []
           this.DATALISTALL3 = datas.teacher_leave ? datas.teacher_leave : []
         });
     },

      getEventColor1(event) {
        const now = new Date();
        const eventStart = new Date(event.start);
        if (eventStart < now) {
          return "gray"; // 如果事件已经开始，返回灰色
        } else {
          return ""; // 如果事件还未开始，返回空字符串，使用组件自带颜色
        }
      },
      seachteacher() {
        this.renderShow = false;
        this.jsonShow = false;

        // 获取下面的学生
        this.studentName = "";
        this.studentName_s = "";
        this.listJsonString = "";

        this.handlequeryScheduleTeacherLeave();
        this.listdate();

        this.listJsonString = "";
        this.getStudenList();
        if (this.selectedTeacher) {
          for (let i = 0; i < this.teachers.length; i++) {
            if (this.selectedTeacher == this.teachers[i].id) {
              this.teacherAddress = this.teachers[i].address;
              this.teacherMonStatus = this.teachers[i].monStatus;
              this.teacherSatNum = this.teachers[i].satNum;
              this.teacherSunNum = this.teachers[i].sunNum;
              break;
            }
          }
        } else {
          this.teacherAddress = null;
          this.teacherMonStatus = null;
          this.teacherSatNum = null;
          this.teacherSunNum = null;
        }
      },
      seachtime() {
        this.startTime1 =
          this.value1[0].getFullYear() +
          "-" +
          (this.value1[0].getMonth() + 1) +
          "-" +
          this.value1[0].getDate();
        this.endTime1 =
          this.value1[1].getFullYear() +
          "-" +
          (this.value1[1].getMonth() + 1) +
          "-" +
          this.value1[1].getDate();

        this.listdate();
      },
      // seachtime() {
      //   this.startTime1 =
      //     this.value1[0].getFullYear() +
      //     "-" +
      //     (this.value1[0].getMonth() + 1) +
      //     "-" +
      //     this.value1[0].getDate();

      //   // 将 this.value1[1] 转换为 Date 对象
      //   const endDateObj = new Date(this.value1[1].getTime());

      //   // 将日期减 1
      //   endDateObj.setDate(endDateObj.getDate() - 1);

      //   // 转换为字符串形式
      //   this.endTime1 =
      //     endDateObj.getFullYear() +
      //     "-" +
      //     (endDateObj.getMonth() + 1) +
      //     "-" +
      //     endDateObj.getDate();

      // },

      aa(date1) {
        // 年
        let y = date1.getFullYear();
        // 月
        let m = date1.getMonth() + 1;
        m = m < 10 ? "0" + m : m;
        // 日
        let d = date1.getDate();
        d = d < 10 ? "0" + d : d;
        // 时
        let h = date1.getHours();
        h = h < 10 ? "0" + h : h;
        // 分
        let M = date1.getMinutes();
        M = M < 10 ? "0" + M : M;
        // 秒
        let s = date1.getSeconds();
        s = s < 10 ? "0" + s : s;
        return y + "-" + m + "-" + d;
      },
      //转换时间格式2023-10-13
      formatDate(dateTime) {
        return dateTime.split("T")[0];
      },
      // 日期格式化
      formatConvert(date) {
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();
        if (mymonth < 10) {
          mymonth = "0" + mymonth;
        }
        if (myweekday < 10) {
          myweekday = "0" + myweekday;
        }
        return myyear + "-" + mymonth + "-" + myweekday;
      },
      //条件查询排课列表
      listdate() {
        loadingUtils.startLoading();
        this.lockLoading = true;
        if (!this.startTime1 && !this.endTime1) {
          const now = new Date(); // 获取当前日期
          const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // 获取当前月的第一天
          const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天

          // 格式化日期
          const formatDate = (date) =>
            `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
          // this.startTime1 = this.getPreMonth(formatDate(firstDay))
          // this.endTime1 = this.getNextMonth(formatDate(lastDay))
          this.startTime1 = this.formatConvert(
            new Date(
              firstDay.getFullYear(),
              firstDay.getMonth(),
              firstDay.getDate() - 7
            )
          );
          this.endTime1 = this.formatConvert(
            new Date(
              lastDay.getFullYear(),
              lastDay.getMonth(),
              lastDay.getDate() + 11
            )
          );
        } else {
        }
        // this.startTime1 = "2023-01-01"
        // this.endTime1 = "2025-01-31"
        // 初次加载。。。。=============================>>>>>> 提取缓存数据
        if (this.jsonShow) {
          let selectschedule_Jons = JSON.parse(
            sessionStorage.getItem("selectschedule_Jons")
          );
          let response = {
            data: {
              data: selectschedule_Jons,
            },
          };
          this.getListAssembly(response);
          this.getListAssembly1(response);
          // 赋值，返回到这个页面进行赋值
          window.sessionStorage.setItem("eventsList", JSON.stringify(response));
        }
        // 重新渲染
        else if (this.renderShow) {
          console.log(22222222222222);
          this.handleRender();
        }
        // （上下）月加载
        else {
          // if(type == 1){
          //   this.handleTime(type)
          // }
          // if(type == 0){
          //   this.handleTime(type)
          // }

          //获取上个月信息 ================================>>>>
          let calendarApi = this.$refs["fullCalendar"].getApi();

          let str = calendarApi.view.title.replace("年", "");
          let result = str.replace("月", "");

          let sub = result.substring(4, 6);
          let ysub = result.substring(0, 4);

          let start = `${ysub}-${sub < 10 ? "0" + sub : sub}-01`;
          let end = `${ysub}-${sub < 10 ? "0" + sub : sub}-31`;
          // ====================================================>>>>

          this.STATR_TIME = calendarApi.currentData.currentViewType == "dayGridMonth"  ? start  : this.startTime1
          this.END_TIME = calendarApi.currentData.currentViewType == "dayGridMonth"  ? end  : this.endTime1
          this.handlequeryScheduleTeacherLeave();

          axios
            .post(`${apiBaseUrl}/preScheduled/selectschedule`, {
              teacher_id: this.selectedTeacher,
              page: "",
              limit: "",
              // start_time: this.startTime1,
              // end_time: this.endTime1,
              start_time:
                calendarApi.currentData.currentViewType == "dayGridMonth"
                  ? start
                  : this.startTime1,
              end_time:
                calendarApi.currentData.currentViewType == "dayGridMonth"
                  ? end
                  : this.endTime1,
              // student_id: this.studentName
              student_id: this.listJsonString,
            },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
            .then((response) => {
              this.getListAssembly(response);
              this.getListAssembly1(response);
              window.sessionStorage.setItem(
                "selectschedule_Jons",
                JSON.stringify(response.data)
              );
              // 赋值，返回到这个页面进行赋值
              window.sessionStorage.setItem(
                "eventsList",
                JSON.stringify(response)
              );
            })
            .catch((error) => {
              this.lockLoading = false;
              // console.error(error);
            });
        }

        loadingUtils.endLoading();
      },
      // 重新渲染
      handleRender() {
        const now = new Date(); // 获取当前日期
        const firstDay = new Date(now.getFullYear(), now.getMonth(), 1); // 获取当前月的第一天
        const lastDay = new Date(now.getFullYear(), now.getMonth() + 1, 0); // 获取当前月的下个月的第零天，即当前月的最后一天

        // this.startTime1 = this.formatConvert(new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate() - 7))
        // this.endTime1 = this.formatConvert(new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate() + 11))
        this.startTime1 = this.formatConvert(
          new Date(
            firstDay.getFullYear(),
            firstDay.getMonth(),
            firstDay.getDate()
          )
        );
        this.endTime1 = this.formatConvert(
          new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
        );
        axios
          .post(`${apiBaseUrl}/preScheduled/selectschedule`, {
            page: "",
            limit: "",
            teacher_id: "",
            student_id: "",
            start_time: this.startTime1,
            end_time: this.endTime1,
          },{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((res) => {
            let { data } = res;
            if (data.code == 200) {
              sessionStorage.setItem(
                "selectschedule_Jons",
                JSON.stringify(data.data)
              );
              let selectschedule_Jons = JSON.parse(
                sessionStorage.getItem("selectschedule_Jons")
              );
              let response = {
                data: {
                  data: selectschedule_Jons,
                },
              };
              this.getListAssembly(response);
              this.getListAssembly1(response);
              this.renderShow = false;
              this.jsonShow = true;
            }
          });
      },
      // 上个月时间
      handleTop(num) {
        console.log(num, "numnumnumnum");
        const now = new Date();
        let year = now.getFullYear();
        let month = num;

        // 创建日期对象并设置为指定年份和月份的1号
        let dateObj = new Date();
        dateObj.setFullYear(year);
        dateObj.setMonth(month - 1); // 注意月份从0开始计算，所以需要减去1
        dateObj.setDate(1);

        // 获取当前月份的最大天数
        let maxDaysInMonth = new Date(year, month, 0).getDate();
        // 使用 toISOString() 方法将日期对象转换为 ISO 8601 格式的字符串

        const dateString = new Date(dateObj);
        const formattedDate = dateString.toISOString().slice(0, 10);

        // 输出格式化后的日期字符串
        const formattedDateEnd = new Date(year, month - 1, maxDaysInMonth)
          .toISOString()
          .slice(0, 10);

        this.startTime1 = formattedDate;
        this.endTime1 = formattedDateEnd;
      },
      // 下个月时间
      handleBtm() {
        const now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth();

        // 创建日期对象并设置为指定年份和月份的1号
        let dateObj = new Date();
        dateObj.setFullYear(year);
        dateObj.setMonth(month - 1); // 注意月份从0开始计算，所以需要减去1
        dateObj.setDate(1);

        // 获取当前月份的最大天数
        let maxDaysInMonth = new Date(year, month, 0).getDate();
        // 使用 toISOString() 方法将日期对象转换为 ISO 8601 格式的字符串

        const dateString = new Date(dateObj);
        const formattedDate = dateString.toISOString().slice(0, 10);

        // 输出格式化后的日期字符串
        const formattedDateEnd = new Date(year, month - 1, maxDaysInMonth)
          .toISOString()
          .slice(0, 10);

        this.startTime1 = formattedDate;
        this.endTime1 = formattedDateEnd;
      },
      handleTime(val) {
        if (val == 1) {
          this.handleBtm();
        }
        if (val == 0) {
          this.handleTop();
        }
      },

      handleCourseName(name){
        // let isNameColor = name.substring(2,name.length)
        cosnole.log(name, '=====>')
        // return ''
      },

      // 渲染排课数据块
      getListAssembly(response) {
        this.copyList = response
        let b = [];

        if (this.DATALISTALL1 && this.DATALISTALL1.length > 0) {
             this.DATALISTALL1.forEach(ITMES => {
               b.push({
                 start: ITMES,
                 end: ITMES,
                 courseEndTime: '调休',
                 courseDate:  '',
                 courseTimeOn: ITMES,
                 title: '',
                 ISTIMERED: 1,
               });
             });
        }


        if (this.DATALISTALL2 && this.DATALISTALL2.length > 0) {
             this.DATALISTALL2.forEach(ITMES => {
               b.push({
                 start: ITMES,
                 end: ITMES,
                 courseEndTime: '请假',
                 courseDate:  '',
                 courseTimeOn: ITMES,
                 title: '',
                 ISTIMERED: 1,
               });
             });
         }

         if (this.DATALISTALL3 && this.DATALISTALL3.length > 0) {
             this.DATALISTALL3.forEach(ITMES => {
               b.push({
                 start: ITMES,
                 end: ITMES,
                 courseEndTime: '请假',
                 courseDate:  '',
                 courseTimeOn: ITMES,
                 title: '',
                 ISTIMERED: 1,
               });
             });
         }



        for (let i = 0; i < response.data.data.length; i++) {
          var aa = {
            //回显高一语文、数学
            // 回显高一课程名称
            classEnding: response.data.data[i].classEnding,
            title: response.data.data[i].courseName,
            scheduleId: response.data.data[i].scheduleId,
            isFirst: response.data.data[i].isFirst,
            start:response.data.data[i].courseDate + " " + response.data.data[i].courseTimeOn,
            end: response.data.data[i].courseDate + " " + response.data.data[i].courseEndTime,
            courseStatus: response.data.data[i].courseStatus,
            S:response.data.data[i].courseTimeOn,
            E:response.data.data[i].courseEndTime,
            isColor: response.data.data[i].courseName.substring(2,response.data.data[i].courseName.length),
            isPreScheduled: response.data.data[i].isPreScheduled,
            categoryNo: response.data.data[i].categoryNo === '家庭教育课' ? 2 : 1,
            isClassType:response.data.data[i].isClassType,
            courseTimeOn:response.data.data[i].courseTimeOn,
            courseEndTime:response.data.data[i].courseEndTime,
            toDoTeacherType:response.data.data[i].toDoTeacherType,

            studentName:response.data.data[i].studentName,
            teacherName:response.data.data[i].teacherName,
            courseDate:response.data.data[i].courseDate,
            courseName:response.data.data[i].courseName,
            taskDetail:response.data.data[i].taskDetail,
            taskUserName:response.data.data[i].taskUserName,

          };
          //开始---设置过去段的背景颜色
          var currentTime = new Date();
          var specifiedTime = new Date(aa.start);
          if (currentTime > specifiedTime) {
            aa.color = "darkgray";
            aa.isShowbgcColor = true;
          } else {
            aa.isShowbgcColor = false;
          }
          b.push(aa);
          //结束
        }

        this.calendarOptions.events = b;
        this.calendarOptionss.events = b;



        let ele = document.getElementsByClassName('fc-toolbar-title')[1]

              if( ele && ele.innerHTML){
                 this.ElEinnerHTML = ele.innerHTML
              }else{
                setInterval(()=>{
                  let ele1 = document.getElementsByClassName('fc-toolbar-title')[1]
                  if( ele1 && ele1.innerHTML){
                    this.ElEinnerHTML = ele1.innerHTML
                  }
                },1500)
              }


        loadingUtils.endLoading();
        this.lockLoading = false;
        this.loadingFalg = false;
        // if(this.eventBtn){
        //   this.isHideDetails = true
        // }
      },

      getListAssembly1(response) {
        let b = [];
        for (let i = 0; i < response.data.data.length; i++) {
          var aa = {
            //回显高一语文、数学
            // 回显高一课程名称
            classEnding: response.data.data[i].classEnding,
            title: response.data.data[i].courseName,
            scheduleId: response.data.data[i].scheduleId,
            isFirst: response.data.data[i].isFirst,
            start:response.data.data[i].courseDate + " " + response.data.data[i].courseTimeOn,
            end: response.data.data[i].courseDate + " " + response.data.data[i].courseEndTime,
            courseStatus: response.data.data[i].courseStatus,
            isPreScheduled: response.data.data[i].isPreScheduled,
            S:response.data.data[i].courseTimeOn,
            E:response.data.data[i].courseEndTime,
            categoryNo: response.data.data[i].categoryNo === '家庭教育课' ? 2 : 1,
            isClassType:response.data.data[i].isClassType,
            toDoTeacherType:response.data.data[i].toDoTeacherType,

          };
          //开始---设置过去段的背景颜色
          var currentTime = new Date();
          var specifiedTime = new Date(aa.start);
          if (currentTime > specifiedTime) {
            aa.color = "darkgray";
            aa.isShowbgcColor = true;
          } else {
            aa.color = "darkgray";
            aa.isShowbgcColor = false;
          }
          b.push(aa);
          //结束
        }
        // this.calendarOptionss.events = b;

        loadingUtils.endLoading();
        this.lockLoading = false;
        this.loadingFalg = false;
        // if(this.eventBtn){
        //   this.isHideDetails = true
        // }
      },
      submitForm1(){
        let data = { 
          courseDate: this.courses.date, 
          teacher_id: this.ruleForm.selectedTeacher,
          relativeTime: this.relativeTime,
          num: this.num ? this.num : '',
          checkList: this.checkList && this.checkList.length > 0 ? `[${this.checkList.map(x => `'${x}'`).join(',')}]` : '',
        }
         axios.post(`${apiBaseUrl}/attendanceWXTeacher/queryTeacherLeave`, data,{ headers :{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
          if (res.data.code === 200) {
              if(res.data.data && res.data.data.length > 0){
                let len = res.data.data[0]
                // this.$message.warning(len)
                this.$confirm( len + '确认继续提交？', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.submitForm()
                })
              }else{
                this.submitForm()
              }
          } else {
            this.$message.error('请联系管理员~');
            this.submitForm() 
          }
        }).catch(err => {
          this.$message.error(err,'请联系管理员~');
          this.submitForm() 
        })
      },
      //点击保存
      submitForm() {
        if(!this.ClassType){
          return this.$message({ message:'请选择班型', type:'warning' })
        }
        this.showBtns  = true
        setTimeout(()=>{
          this.showBtns  = false
        },2000)
        // console.log(this.checkList);
        // retrun;
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            // 表单验证通过，执行保存操作
            if (this.isFirst == 2) {
              this.isFirst = 2;
            }
            const data = {
              // num: this.num,
              // checkList: this.checkList,
              // relative_Time: this.relative_Time,
              // radio: this.radio,
              num: this.num,
              checkList: this.checkList,
              relativeTime: this.relativeTime,
              educationType: this.educationType,
              isFirst: this.isFirst,
              courseSchedulingNo: 1,
              courseId: this.id1,
              classId: 1,
              teacherId: this.ruleForm.selectedTeacher,
              categoryId: this.categoryId,
              courseDate: this.formatDate(this.courses.date),
              courseTimeOn: this.ruleForm.startTime,
              courseEndTime: this.ruleForm.endTime,
              classroom: "一教室",
              numberOfClassDeductions: 0,
              recurrentScheduling: 0,
              canMakeAnAppointment: 0,
              courseNotes: "备注：赶紧上课思密达",
              //studentId: this.studentIds.join(","),
              studentId: '[' + this.studentIds +']',
              productClassType: this.ClassType,
              classPersonType: this.classPersonType
            };
            axios
              .post(`${apiBaseUrl}/preScheduled/add`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
              .then((res) => {
                if (res.data.code == 200) {
                  //成功
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                  //如表单还有数据没有清空掉就给默认值
                  // this.ruleForm.selectedTeacher = "";
                  // (this.ruleForm.startTime = ""),
                  //   (this.ruleForm.endTime = ""),
                  //   (this.studentIds = []);

                  this.ruleForm.startTime = ""
                  this.ruleForm.endTime = ""
                  this.studentIds = []
                  // this.studentList=[];
                  this.classPersonType = ''
                  this.ClassType = ''
                  this.$refs.ruleForm.resetFields();
                  this.listdate();
                  this.scheduleId = res.data.id;
                  this.dialogVisible = false;
                } else {
                  //失败
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              })
              .catch((error) => {
                console.error(error);
              });
          } else {
            // 表单验证未通过，提示错误
            console.error("请填写完整的表单信息");
            return false;
          }
        });
      },

      handleEvent(event){
        this.dialogVisible = event
        this.listdate();
      },
      //查询教师列表
      fetchTeachers() {
        let teacherlist_Jons = JSON.parse(
          sessionStorage.getItem("teacherlist_Jons")
        );
        let param = {
          realname: "全部老师",
          id: "",
        };
        this.teachers = [param, ...teacherlist_Jons];
        axios.get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          }) // 请替换为你的API URL
           .then(response => {
             let param = {
               realname: "全部老师",
               id: ""
             }
             this.teachers = [param, ...response.data.data]
           })
           .catch(error => {
             console.error(error);
           });
      },
      //查询课程列表
      fetchCourses() {
        let categorylist_Jons = JSON.parse(
          sessionStorage.getItem("categorylist_Jons")
        );
        this.courses = categorylist_Jons;
        // axios
        //   .get(`${apiBaseUrl}/schedule/categorylist`)
        //   .then(response => {
        //     this.courses = response.data.data;
        //   })
        //   .catch(error => {
        //     console.error(error);
        //   });
      },
      //查询学生列表(先传默认0，到时候改成teacherId)
      fetchStudents() {
        //判断这个teacherId是否为空，不为空则查询学生列表，为空则不查询
        // if (!this.ruleForm.selectedTeacher) {
        //   return;
        // }
        // axios
        //   .get(
        //     `${apiBaseUrl}/schedule/studentlist/` + this.ruleForm.selectedTeacher
        //   )
        //   .then(response => {
        //     // this.studentList = response.data.data;
        //   })
        //   .catch(error => {
        //     console.error(error);
        //   });
      },

      handleChanges(e){
        console.log(this.ClassType, 'this.ClassType')
        if(this.ClassType){
            if(this.ClassType === 1){
               this.classPersonTypeList = [{id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'}, ]
            }
            else if(this.ClassType === 2){
               this.classPersonTypeList = [{id:2,name:'孩子和父亲'}, {id:3,name:'孩子和母亲'}, {id:6,name:'父亲和母亲'},]
            }
            else if(this.ClassType === 3){
               this.classPersonTypeList = [ {id:7,name:'孩子、父亲、母亲'} ]
            }else{
              this.classPersonTypeList = [
                {id:1,name:'孩子'},{id:4,name:'父亲'}, {id:5,name:'母亲'},
                {id:2,name:'孩子和父亲'}, {id:3,name:'孩子和母亲'}, {id:6,name:'父亲和母亲'},
                {id:7,name:'孩子、父亲、母亲'}
              ]
            }

        }else{
          this.classPersonTypeList = []
          // this.$message({ message:'请选择班型~' , type:'warning' })
        }
      },

      handleshowExportPDF(){
        this.showExportPDF = false

        // this.$nextTick(()=>{
        //     this.ElEinnerHTML = ''

        //     let eleShow = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr')[1]
        //     eleShow.style.display = ''

        //     let eleShow1 = document.getElementsByClassName('fc-header-toolbar fc-toolbar fc-toolbar-ltr')[0]
        //     eleShow1.style.display = ''
        // })

        // this.getoptionList()
        // this.getListAssembly(this.copyList)


        // let ele = document.getElementsByClassName('showDing')[0]
        // ele.style.height = '10px'
        // ele.style.opacity = '0'
      },

      handleButtonClick(courseId) {
        console.log("点击了课程：", courseId);
      },
      handleWeekendsToggle() {
        this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
        this.calendarOptionss.weekends = !this.calendarOptionss.weekends; // update a property
      },

      // 点击排课出现弹层
      handleEventClick(clickInfo) {


        if(clickInfo.event._def.extendedProps.isClassType === 3 || clickInfo.event._def.extendedProps.isClassType === '3'){

            this.isShowRepresentativeObj.toDoTeacherType = clickInfo.event._def.extendedProps.toDoTeacherType
            this.isShowRepresentativeObj.studentName = clickInfo.event._def.extendedProps.studentName
            this.isShowRepresentativeObj.teacherName = clickInfo.event._def.extendedProps.teacherName
            this.isShowRepresentativeObj.courseDate = clickInfo.event._def.extendedProps.courseDate
            this.isShowRepresentativeObj.courseName = clickInfo.event._def.extendedProps.courseName
            this.isShowRepresentativeObj.taskDetail = clickInfo.event._def.extendedProps.taskDetail
            this.isShowRepresentativeObj.taskUserName = clickInfo.event._def.extendedProps.taskUserName
            this.isShowRepresentativeObj.courseTimeOn = clickInfo.event._def.extendedProps.courseTimeOn
            this.isShowRepresentativeObj.courseEndTime = clickInfo.event._def.extendedProps.courseEndTime

            this.isShowRepresentative = true
            return
        }

        this.fetchStudents();
        this.btnInitialViewSelect = clickInfo.view.type;
        //点击按钮显示新增排课弹窗
        // console.log(this.calendarOptions.events);
        // console.log(clickInfo.event._def.extendedProps.scheduleId);
        this.courses.categoryName = clickInfo.event._def.title;
        this.categoryId = clickInfo.event._def.publicId;
        // console.log(clickInfo.event);
        this.scheduleId = clickInfo.event._def.extendedProps.scheduleId; //排课id
        this.courses.date = clickInfo.event.startStr;
        // this.ruleForm.startTime=clickInfo.event.startStr.split("T")[1].split("+")[0].substr(0,5)

        if (clickInfo.event.endStr.length >= 10) {
          this.ruleForm.endTime = clickInfo.event.endStr.substr(11, 16).substr(0, 5);
        }

        if (clickInfo.event.startStr.length >= 10) {
          this.ruleForm.startTime = clickInfo.event.startStr
            .substr(11, 16)
            .substr(0, 5);
        } else {
          this.diagnosisOff.startTimeHour = "";
          this.diagnosisOff.endTimeHour = "";
        }
        this.id1 = clickInfo.event.id; //课程id
        if (typeof this.scheduleId !== "undefined") {
          //如果有就跳转排课详情
          const scheduleId = clickInfo.event._def.extendedProps.scheduleId;
          this.showNewSchedule(scheduleId);
        } else {
          const scheduleId = clickInfo.event._def.extendedProps.scheduleId;
          // const scheduleId = data.list[0].scheduleId;
          // axios
          //   .get(`${apiBaseUrl}/schedule/selectscheduleone/${scheduleId}`)
          //   .then(res => {
          //     this.startTime = res.data.data.list.courseTimeOn;
          //     this.endTime = res.data.data.list.courseEndTime;

          //     // 将回显的排课信息数据保存到组件的属性中
          //     // this.courseScheduleData = res.data.data.list;
          //     this.courseScheduleData = response.data.data.list;
          //     // console.log(this.courseScheduleData);
          //     // const data = response.data;
          //   })
          //   .catch(error => {
          //     console.log(error);
          //   });


          // this.ruleForm.selectedTeacher = this.selectedTeacher
          let ids = []
          if(this.studentName_s){
             ids[0] = this.studentName_s
             if(this.studentName){
               ids[1] = this.studentName
             }
          }else{
            if(this.studentName){
              ids[1] = this.studentName
            }
          }


          this.studentIds = ids


          axios.post(`${apiBaseUrl}/preScheduled/getClassType`, { categoryId: this.categoryId, studentId:  '[' + this.studentIds + ']' },{ headers:{'authorization': sessionStorage.getItem('tokenInfo')} }).then((res) => {
            let data = res.data.data
            if(data && data.length > 0){
                data.forEach((itme)=>{
                  itme.id = itme.classType
                  itme.name = itme.classType === 1 ? '1v1' : itme.classType === 2 ? '1v2' : '1v3'
                })
                this.classPersonTypeList1 = data

            }else{
                this.classPersonTypeList1 =[]
                this.ClassType = ''
                this.classPersonType = ''
            }
          })


          // console.log(clickInfo.event._def.title);
          this.dialogVisible = true; // 点击按钮后弹层显示
        }
        this.getAllStudents();
      },

      s(events) {
        let index = events.length;
        let eventStop = events[index - 1];

        this.currentEvents = events;
      },
      //筛选操作，将选择的学员放到选择框中
      handleSelectionChange(arr) {
        const aa = [];
        for (let i = 0; i < arr.length; i++) {
          aa.push(arr[i].id);
        }
        this.studentIds = aa;
      },
      // 显示排课详情跳转路由
      showNewSchedule(scheduleId) {
        this.parentScheduleId = scheduleId;
        this.isHideDetails = true;

        // this.renderShow = false
        // this.jsonShow = false
        // this.listdate();

        // this.$router.push({
        //   path: "/scheduleDetails",
        //   query: { scheduleId: scheduleId ,initialView:this.btnInitialViewSelect},
        // });
      },
      showDetails() {
        // this.$refs.detailsDialog.openDialog();
      },
      getPreMonth(date) {
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中月的天数
        var year2 = year;
        var month2 = parseInt(month) - 1;
        if (month2 == 0) {
          year2 = parseInt(year2) - 1;
          month2 = 12;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }
        var t2 = year2 + "-" + month2 + "-" + day2;
        return t2;
      },
      getNextMonth(date) {
        var arr = date.split("-");
        var year = arr[0]; //获取当前日期的年份
        var month = arr[1]; //获取当前日期的月份
        var day = arr[2]; //获取当前日期的日
        var days = new Date(year, month, 0);
        days = days.getDate(); //获取当前日期中的月的天数
        var year2 = year;
        var month2 = parseInt(month) + 1;
        if (month2 == 13) {
          year2 = parseInt(year2) + 1;
          month2 = 1;
        }
        var day2 = day;
        var days2 = new Date(year2, month2, 0);
        days2 = days2.getDate();
        if (day2 > days2) {
          day2 = days2;
        }
        if (month2 < 10) {
          month2 = "0" + month2;
        }

        var t2 = year2 + "-" + month2 + "-" + day2;
        return t2;
      },
      getoptionList() {
        this.calendarOptions = {
          handleWindowResize: true,
          eventColor: this.getEventColor,
          firstDay: 1,
          allDaySlot: false,
          firstHour: 6,
          slotMinTime: "06:00:00",
          slotMaxTime: "24:00:00",
          plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
          datesSet: this.handleDatesSet,
          headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          },
          buttonText: {
            today: "今天",
            dayGridMonth: "月",
            timeGridWeek: "周",
            timeGridDay: "日",
          },
          locale: "zh-cn",
          initialView: "timeGridWeek",
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          eventDidMount: function (info) {

            // if (info.event.extendedProps.isClassType === 2) {
            //     info.el.style.background = "#3788d8";
            //     info.el.style.color = "#fff";
            // }



            if (info.event.extendedProps.isShowbgcColor) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            } else {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                // if(this.tabPosition === 'jiatingke'){
                //   info.el.style.background = "#3788d8";
                //   info.el.style.color = "#fff";
                // }else{
                //   info.el.style.background = "#3788d8";
                // }
              }
            }
            if (info.event.extendedProps.classEnding == 1 && info.event.extendedProps.isFirst !== 1) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "orange";
                info.el.style.borderColor = "orange";
              }
              if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    // info.el.style.color = "#fff";
              }

            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding == 1
            ) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "#E380E3";
               info.el.style.borderColor = "#E380E3"
              }
              if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    info.el.style.color = "#fff";
              }

            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "#54bcbd";
              info.el.style.borderColor = "#54bcbd";
              }
            }
             if ( info.event.extendedProps.isPreScheduled == 1 ) {
                  info.el.style.background = "rgb(235 82 20)";
                  info.el.style.borderColor = "rgb(38 216 217)";

                 if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    info.el.style.color = "#fff";
                 }
             }

             if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    info.el.style.color = "#fff";
             }

             if(info.event.extendedProps.ISTIMERED === 1){
                info.el.style.background = "#e10909";
                info.el.style.borderColor = "#e10909";
                info.el.style.pointerEvents = "none";
                info.el.style.cursor = "not-allowed";
             }

             if(info.event.extendedProps.isShowbgcColor && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "darkgray";
                  info.el.style.color = "#000";
              }

              if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "#6ced62";
                  info.el.style.color = "#000";
              }


          }, //事件挂载
          events: [],
          customButtons: {
            next: { click: this.nextClick },
            prev: { click: this.prevClick },
          },
          eventColor: function (event) {
            if (event.start.isBefore(new Date())) {
              return "f0f0f0";
            } else {
              return "#008000";
            }
          },
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents,
        };

        this.calendarOptionss = {
          handleWindowResize: true,
          eventColor: this.getEventColor,
          firstDay: 1,
          allDaySlot: false,
          firstHour: 6,
          slotMinTime: "06:00:00",
          slotMaxTime: "24:00:00",
          plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
          datesSet: this.handleDatesSet,
          headerToolbar: {
            left: "prev,next today",
            center: "title",
            right: "dayGridMonth,timeGridWeek,timeGridDay",
          },
          buttonText: {
            today: "今天",
            dayGridMonth: "月",
            timeGridWeek: "周",
            timeGridDay: "日",
          },
          locale: "zh-cn",
          initialView: "dayGridMonth",
          editable: true,
          selectable: true,
          selectMirror: true,
          dayMaxEvents: true,
          weekends: true,
          eventDidMount: function (info) {


            // if (info.event.extendedProps.isClassType === 2) {
            //     info.el.style.background = "#3788d8";
            //     info.el.style.color = "#fff";
            // }

            if (info.event.extendedProps.isShowbgcColor) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            } else {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              }
            }
            if (
              info.event.extendedProps.classEnding == 1 &&
              info.event.extendedProps.isFirst !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
                info.el.style.borderColor = "darkgray";
              }

            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding == 1
            ) {
              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
              info.el.style.borderColor = "darkgray"
              }
            }
            if (
              info.event.extendedProps.isFirst == 1 &&
              info.event.extendedProps.classEnding !== 1
            ) {

              if(this.showExportPDF){
                info.el.style.background = "darkgray";
              }else{
                info.el.style.background = "darkgray";
               info.el.style.borderColor = "darkgray";
              }
            }
             if ( info.event.extendedProps.isPreScheduled == 1 ) {
                  info.el.style.background = "rgb(235 82 20)";
                  info.el.style.borderColor = "rgb(38 216 217)";

                if (info.event.extendedProps.isClassType === 2) {
                    info.el.style.background = "#3788d8";
                    // info.el.style.color = "#fff";
                 }
             }
            if(info.event.extendedProps.ISTIMERED === 1){
                info.el.style.background = "#e10909";
                info.el.style.borderColor = "#e10909";
                info.el.style.pointerEvents = "none";
                info.el.style.cursor = "not-allowed";
             }
             if(info.event.extendedProps.isShowbgcColor && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "darkgray";
                  info.el.style.color = "#000";
              }

              if(info.event.extendedProps.classEnding === 1 && info.event.extendedProps.isClassType === 2){
                  info.el.style.background = "#6ced62";
                  info.el.style.color = "#000";
              }


          }, //事件挂载
          events: [],
          customButtons: {
            next: { click: this.nextClick },
            prev: { click: this.prevClick },
          },
          eventColor: function (event) {
            if (event.start.isBefore(new Date())) {
              return "f0f0f0";
            } else {
              return "#008000";
            }
          },
          eventClick: this.handleEventClick,
          eventsSet: this.handleEvents,
        };
      },
      oneTouch() {
        this.$confirm("此操作将一键节课, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.dialogVisibles = true;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消节课",
            });
          });
      },

      okTouch() {
        // let data = { courseDate: this.courseDate1 };
        let data = { courseStartDate: this.courseDate1[0], courseEndDate: this.courseDate1[1] }
        axios
          .post(`${apiBaseUrl}/schedule/classEndingForAll`, data,{
            headers:{
              'authorization': sessionStorage.getItem('tokenInfo')
            }
          })
          .then((res) => {
            if (res.data.code == 200) {
              // this.$message({
              //   type: 'success',
              //   message: '结课成功'
              // });

              // 重置排课绘制表格  === >>>开启缓
              this.jsonShow = false;
              this.renderShow = false;
              this.listdate();
              this.courseDate1 = []

              this.dialogVisibles = false;
            } else {
              this.$message({
                type: "error",
                message: "结课失败",
              });
              this.dialogVisibles = false;
            }
          });
      },
      // 结课详情 触发===>>>刷新渲染
      handleEventEmit() {
        let calendarApi = this.$refs["fullCalendar"].getApi();

        let str = calendarApi.view.title.replace("年", "");
        let result = str.replace("月", "");

        let sub = result.substring(4, 6);
        let ysub = result.substring(0, 4);

        let start = `${ysub}-${sub < 10 ? "0" + sub : sub}-01`;
        let end = `${ysub}-${sub < 10 ? "0" + sub : sub}-31`;

        this.endTime1 = end;
        this.startTime1 = start;

        console.log(this.endTime1, "this.endTime1 ");
        console.log(this.startTime1, "this.startTime1 ");

        // this.isHideDetails = false
        // this.eventBtn = true
        this.jsonShow = false;
        this.renderShow = false;
        this.listdate();
      },
    },
  };
  </script>
  <style lang="less" scoped>
  .c-panel {
    display: flex;
    text-align: left;
    align-items: center;
    padding: 10px;

    span {
      font-size: 14px;
      color: #666;
    }
  }

  .manage {
    margin-left: -10px;
  }

  .hr dottde {
    border-style: dotted;
  }

  .hr {
    display: block;
    height: 0;
    overflow: hidden;
    font-size: 0;
    border-width: 1px 0 0;
    border-top: 1px solid #e3e3e3;
    margin: 10px 0;
    border-top-color: rgba(0, 0, 0, 0.11);
  }

  .colorButton {
    width: 20px;
    // float: right;
    height: 15px;
    border-radius: 3px;
    border: 2px solid #ddd;
    background-color: var(--fc-event-bg-color);
  }

  .dragheader {
    color: #8a6d3b;
    font-size: 18px;
    font-weight: 600;
    line-height: 1.1;
  }

  h2 {
    margin: 0;
    font-size: 16px;
  }

  ul {
    margin: 0;
    padding: 0 0 0 1.5em;
  }

  li {
    // margin: 1.5em 0;
    padding: 0;
  }

  b {
    /* used for event dates/times */
    margin-right: 3px;
  }

  .demo-app {
    display: flex;
    min-height: 100%;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
    margin-top: -30px;
  }

  .demo-app-sidebar {
    width: 300px;
    line-height: 1.5;
    background: #eaf9ff;
    border-right: 1px solid #d3e2e8;
  }

  .demo-app-sidebar-section {
    padding: 2em;
  }

  .demo-app-main {
    flex-grow: 1;
    padding: 3em 3em 0 1.5em;
  }

  .fc {
    /* the calendar root */
    // max-width: 950px;
    margin-left: -13px;
  }
  .el-upload{
    border:0px !important;
  }
  html,
  body {
    margin: 0;
    padding: 0;
    font-family: Arial, Helvetica Neue, Helvetica, sans-serif;
    font-size: 14px;
  }

  .fcevent {
    display: flex;
    justify-content: space-between;
  }

  #external-events {
    position: unset !important;
    float: right;
    margin-left: 20px;
    margin-top: 10px;
    // z-index: 2;

    // width: 150px;
    width: 235px;

    padding: 0 10px;
    border: 1px solid #ccc;
    background: #eee;
  }

  #external-events .fc-event {
    cursor: move;
    margin: 10px 0;
    padding: 1px 1px 2px 2px;
  }

  #calendar-container {
    position: relative;
    z-index: 1;
    margin-left: 200px;
  }

  #calendar {
    max-width: 1100px;
    margin: 20px auto;
  }

  .demo-app-calendar .fc-past-event {
    background-color: gray;
  }

  .add_andmagess {
    text-align: left;
    // padding-left:10px
  }

  .add_andmagess span {
    margin-left: 10px;
    margin-right: 10px;
    color: red;
  }

  /deep/.fc-theme-standard .fc-popover {
    z-index: 4;
  }

  /deep/.el-dialog__body {
    padding-top: 0;
  }
  .btns {
    background-color: #428bca;
    border-color: #428bca;
    color: #fff;
  }

   .el-select-dropdown__item{
    padding-left: 10px !important;
  }

  .s{
    opacity: 0; top: 0; height: 10px;
  }


  /* 兼容移动端 */
  </style>



// WEBPACK FOOTER //
// src/PreSchedule/PreSchedule-new.vue